import { useComposablePage } from '@bnnvara/composable';
import React from 'react';

import withBrandedComposablePage from '../../../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../../../layouts/ComposablePageLayout';
import CatalogIndexPageQuery from './CatalogIndexPage.gql';
import pageData from './CatalogIndexPage.json';
import notFoundPageData from './CatalogIndexPageNotFound.json';

const CatalogIndexPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData, notFoundPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: CatalogIndexPageQuery,
  isFound: (data) => data.brand.catalog,
})(CatalogIndexPage);
